import type {
  InsertQuestionnaireTemplateInput,
  InsertQuestionnaireTemplateMutation,
  InsertQuestionnaireTemplateMutationVariables,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertQuestionnaireTemplateDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

/**
 * Maps the TRPC mutation response to match the GraphQL mutation structure.
 */
const mapTrpcResponseToGraphQL = (trpcData: {
  Id: string;
}): InsertQuestionnaireTemplateMutation => ({
  insertQuestionnaireTemplateApi: {
    __typename: 'IdOutput',
    Id: trpcData.Id,
  },
});

export const useInsertQuestionnaireTemplate = createMutationHook({
  name: 'insertQuestionnaireTemplate',
  isIdempotentCreate: true,
  mutationOptions: (trpc, onSuccess, requestContext) =>
    trpc.frontend.questionnaireTemplate.insert.mutationOptions({
      onSuccess,
      trpc: { context: requestContext },
    }),
  mapInput: (input: {
    variables: InsertQuestionnaireTemplateMutationVariables;
  }): InsertQuestionnaireTemplateInput => {
    const object = input.variables.object;

    return {
      Title: object?.Title ?? '',
      Description: object?.Description,
      CustomAttributeData: object?.CustomAttributeData,
      OwnerUserIds: object?.OwnerUserIds ?? [],
      OwnerGroupIds: object?.OwnerGroupIds ?? [],
      ContributorUserIds: object?.ContributorUserIds ?? [],
      ContributorGroupIds: object?.ContributorGroupIds ?? [],
      ViewerUserIds: object?.ViewerUserIds,
      ViewerGroupIds: object?.ViewerGroupIds,
      TagTypeIds: object?.TagTypeIds ?? [],
      DepartmentTypeIds: object?.DepartmentTypeIds ?? [],
    };
  },
  invalidate: (trpc) => [
    trpc.frontend.questionnaireTemplate.register.queryKey(),
    trpc.frontend.questionnaireTemplate.getById.queryKey(),
  ],
  mapResponse: (result: { Id: string }): InsertQuestionnaireTemplateMutation =>
    mapTrpcResponseToGraphQL(result),
  graphqlDocument: InsertQuestionnaireTemplateDocument,
  graphqlVariables: (input: {
    variables: InsertQuestionnaireTemplateMutationVariables;
  }) => input.variables,
  evictFields: ['questionnaire_template'],
});
